import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PasswordPair, passwordPairReady } from "../../components/neu/PasswordPair";
import { NeuButton } from "../../components/neu/Neu";

export const SetPasswordForm = ({ onSubmit, busy, error }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ password: "", confirm: "" });
  const ready = passwordPairReady(form.password, form.confirm);

  const submit = (e) => {
    e.preventDefault();
    if (!ready) return;
    onSubmit(form.password);
  };

  return (
    <form className="mt-6 space-y-4" onSubmit={submit}>
      <PasswordPair
        testId="set-password"
        password={form.password}
        confirm={form.confirm}
        onPasswordChange={(password) => setForm({ ...form, password })}
        onConfirmChange={(confirm) => setForm({ ...form, confirm })}
        confirmPlaceholder={t("join.confirmPassword")}
      />
      {error ? (
        <p data-testid="set-password-error" className="text-sm font-semibold text-destructive">
          {error}
        </p>
      ) : null}
      <NeuButton
        variant="primary"
        type="submit"
        data-testid="set-password-submit"
        disabled={busy || !ready}
        className="w-full py-4"
      >
        {busy ? t("app.loading") : t("reset.save")}
      </NeuButton>
    </form>
  );
};
